// Small, always-needed bits of this page (path, title, dates), kept apart from the
// page text so the main app bundle does not have to carry the whole page.
export const LISTENER_GUIDE_PATH = '/listener-guide';

export const LISTENER_GUIDE_META = {
  title: 'Volunteer as a Listener | Zuzu Ambassador Guide | Zuzu Club',
  description: 'A short, friendly guide for Zuzu listeners: example chats, words that help, what to do when it gets heavy, and the do\'s and don\'ts.',
  image: 'https://www.zuzu.club/og/zuzu-club-listener-guide.jpg?v=10',
  alt: 'Be the kind stranger someone needs tonight. A short guide for Zuzu listeners.',
};

// A personal link can carry a first name: /listener-guide?name=Asha.
// Letters, spaces, dots, apostrophes and hyphens only, up to 30 characters.
export function cleanName(raw: string | null): string | null {
  const name = (raw ?? '').replace(/[^\p{L}\p{M} .'-]/gu, '').replace(/\s+/g, ' ').trim().slice(0, 30);
  return name.length >= 2 ? name : null;
}
